import { Delete } from '@mui/icons-material';
import LoadingButton from '@mui/lab/LoadingButton';
import { Box, Button, DialogContent, DialogTitle, Typography } from '@mui/material';
import { Link, useParams } from 'react-router-dom';
import { useDeleteScenarioMutation } from '../../../../../api/gql';
import { useSafeNavigation } from '../../../../../hooks/useSafeNavigation';
import { notify } from '../../../../../utils/notification';

export const DeleteScenarioPage = () => {
  const { safeNavigate } = useSafeNavigation();
  const { scenarioId } = useParams();

  const { mutate, isPending: isMutating } = useDeleteScenarioMutation({
    onSuccess: () => {
      notify.positive({ message: 'Scénář byl smazán.' });
      safeNavigate(`/admin/universal-reminding/scenarios`);
    },
    onError: (error) => {
      console.error(error);
      notify.negative({
        message: 'Scénář se nepodařilo smazat. Kontaktuje podporu.',
      });
    },
  });

  const onSubmit = () => {
    if (!scenarioId) {
      throw new Error('Scenario ID is required');
    }

    mutate({ id: scenarioId });
  };

  return (
    <>
      <DialogTitle>{'Smazání scénáře'}</DialogTitle>
      <DialogContent dividers sx={{ position: 'relative' }}>
        <Typography whiteSpace={'break-spaces'}>
          {
            'Smazání scénáře znemožní v budoucnu použít tento scénář pro upomínání. Stávající upomínání dle tohoto scénáře doběhnou dle plánu.\n\nOpravdu si přejete smazat scénář?'
          }
        </Typography>

        <Box mt={4} display={'flex'} flexDirection={'column'} gap={2}>
          <LoadingButton
            loading={isMutating}
            variant={'contained'}
            size={'large'}
            color={'error'}
            onClick={onSubmit}
            startIcon={<Delete />}
          >
            {'Ano, smazat scénář'}
          </LoadingButton>
          <Button component={Link} to={'..'}>
            {'Zrušit'}
          </Button>
        </Box>
      </DialogContent>
    </>
  );
};
